// extracted by mini-css-extract-plugin
export default {"jobProfilesFormContent":"jobProfilesFormContent---ilqDr"};